import { Component } from '@angular/core';
import { NavigationService } from '../../../services/navigation/navigation.service';

@Component({
  selector: 'app-static-content-become-partner',
  templateUrl: './static-content-become-partner.component.html',
  styleUrls: ['./static-content-become-partner.component.scss'],
})
export class StaticContentBecomePartnerComponent {
  constructor(private navigationService: NavigationService) {}

  public navigateToPartnerLandingPage() {
    this.navigationService.navigateToPartnerLandingPage();
  }
}
